import React from "react";
import ContractDetails from "../../components/ContractDetails/ContractDetails.component";

const CompaniesContainer= (props)=>{
    return (
        <ContractDetails {...props}></ContractDetails>
    )
}

export default CompaniesContainer;
